import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isHorrorRaceV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("horror-race", pathname);
}

export function resolveHorrorRaceRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isHorrorRaceV2Path(pathname) ? "v2" : "legacy";
}

export function resolveHorrorRaceGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isHorrorRaceV2Path(pathname) ? "game-platform" : "legacy";
}
